import { useCallback, useRef } from 'react'

// Countdown, counter, and media-less exits can race each other. Keep the
// start sound and navigation paired, and allow that pair only once per screen.
const useStartSoundTransition = (playSound: () => void, nextStep: () => void) => {
  const hasAdvanced = useRef(false)

  return useCallback(() => {
    if (hasAdvanced.current) return

    hasAdvanced.current = true
    playSound()
    nextStep()
  }, [nextStep, playSound])
}

export default useStartSoundTransition
